<template>
    <div id="main-container" v-if="!isAdmin">
        <nav-bar ></nav-bar>
        
        <div id="page">
            <router-view></router-view>
        </div>
    </div>
    <div id="admin-container" v-if="isAdmin">
        <admin-nav-bar></admin-nav-bar>
        <div id="page">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

export default {
  data(){
    return{
        isAdmin: true,
    };
  },
  methods:{

  },
  mounted(){
    if (localStorage.getItem("confirmation") === "onaylandi") {
        this.isAdmin = true;
    }else{
        this.isAdmin = false;
    }    
  }

}
</script>

<style>
*{
    box-sizing: border-box;
}

#admin-container{
    overflow: auto;
    display: flex;
    flex-direction: row;
    background-color: aliceblue;
}

#main-container{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
}

@media (min-width: 769px){
    #main-container{
        background-image: url('../src/assets/homepage-images/72.webp');
        /* background-image: url('../src/assets/images/80.jpg'); */
        width: 100%;
    }
}

@media (max-width: 768px){
    #main-container{
        background-image: url('../src/assets/homepage-images/64.webp');
        width: 100%;
    }
}
</style>
